(function ($h) {
    $h.registerHelper('brunchDate', function (timestamp, options) {
        if (timestamp) {
            return B.Util.brunchDate(timestamp);
        }
    });

    $h.registerHelper('ifCond', function (v1, v2, options) {
        if (v1 == v2) {
            return options.fn(this);
        }

        return options.inverse(this);
    });

    $h.registerHelper('ifCond2', function (v1, operation, v2, options) {
        var condition = false;
        switch (operation) {
            case '>':
                condition = v1 > v2;
                break;
            case '>=':
                condition = v1 >= v2;
                break;
            case '<':
                condition = v1 < v2;
                break;
            case '<=':
                condition = v1 <= v2;
                break;
            case '||':
                condition = v1 || v2;
                break;
            case '!=':
                condition = v1 != v2;
                break;
        }

        if (condition) {
            return options.fn(this);
        }

        return options.inverse(this);
    });

    $h.registerHelper('numberFormat', function (num) {
        if (!isNaN(num)) {
            return B.Util.numberFormat(num);
        }

        return num;
    });

    $h.registerHelper('convertReadSeconds', function (seconds) {
        return B.Util.convertReadSeconds(seconds);
    });

    $h.registerHelper('getRandomColor', (function () {
        var colors = ['#CBCBCB', '#BAC0C7', '#C3BDB7', '#BDCAC3'];
        return function () {
            var num = Math.round(Math.random() * 3);
            console.log(num);
            return colors[num];
        };
    })());
})(Handlebars);
